import type { CharterCabinClass } from '../charter.types';

export const SEAT_OVERRIDE_DEPARTING_DEP_AIRPORT = 'MEL';
export const SEAT_OVERRIDE_DEPARTING_ARR_AIRPORT = 'MLE';
export const SEAT_OVERRIDE_RETURNING_DEP_AIRPORT = 'MLE';
export const SEAT_OVERRIDE_RETURNING_ARR_AIRPORT = 'MEL';

export const CABIN_LABELS: Record<CharterCabinClass, string> = {
  business: 'Business',
  economy: 'Economy',
  lux_row: 'Economy Extra',
  lux_row_pax_one: 'Economy Extra for One',
  premium_economy: 'Premium Economy',
};

export const MANUAL_BLOCK_REASON_LABELS = {
  crew_rest: 'Crew rest',
  vvip: 'VVIP',
  lux_row: 'Economy Extra',
  dummy: 'Dummy block',
} as const;

export type ManualBlockReason = keyof typeof MANUAL_BLOCK_REASON_LABELS;

export type SeatOverrideFormValue = {
  isAvailable: boolean;
  blockReason?: ManualBlockReason;
  price: number;
};
